import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import AggregateFromBaseProductTableMixin from "./AggregateFromBaseProductTableMixin";

const MATERIAL_SUBTYPE = "MaterialType";
const PRODUCT_TYPE = "ProductType";

const AggregateFromMaterialTable = declare(AggregateFromBaseProductTableMixin, {
	/**
	 * @override
	 * Add filter for selected Material Type
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		this.modifyQuery(MATERIAL_SUBTYPE, PRODUCT_TYPE, ql);
	},
});

export = AggregateFromMaterialTable;